function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M36.1409 8C18.3896 8 4 22.3382 4 40.0261C4 57.714 18.3896 72.0521 36.1409 72.0521C53.8922 72.0521 68.2818 57.714 68.2818 40.0261C68.2818 22.3382 53.8922 8 36.1409 8Z",
  fill: "#F2F2F2"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M34.849 8.02539C35.2775 8.00852 35.7081 8 36.1407 8C36.5734 8 37.004 8.00852 37.4325 8.02539H68V35.7685C68.1857 37.1613 68.2815 38.5825 68.2815 40.0259C68.2815 41.4694 68.1857 42.8905 68 44.2834V52.0254H65.9495C61.1842 63.7678 49.6336 72.0518 36.1407 72.0518C22.6479 72.0518 11.0973 63.7678 6.33202 52.0254H4V40.0259V8.02539H34.849Z",
  fill: "#D9D9D9"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_3572_201942)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M52.8564 57.582C52.5436 57.6084 52.2217 57.5688 51.9079 57.4531L38.9027 52.6529C37.7603 52.2315 37.1753 50.9631 37.5978 49.8207C38.0192 48.6783 39.2875 48.0944 40.43 48.5158L53.4352 53.316C54.5776 53.7374 55.1625 55.0058 54.7401 56.1482C54.4344 56.9778 53.6819 57.513 52.8553 57.582H52.8564Z",
  fill: "#8DE1FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.6753 68.748C38.6529 68.6008 38.4377 68.615 38.4336 68.7632L38.6753 68.748Z",
  fill: "#8DE1FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.4002 63.6409C56.8777 60.8352 56.1588 56.5326 54.599 56.0086C47.7039 53.6913 43.6562 53.6537 39.8492 52.6819C31.2603 50.4895 28.5449 53.997 30.6774 56.2391C34.1879 59.9294 42.592 64.0979 49.7227 65.9288C51.8613 65.3794 53.4332 64.4848 55.4002 63.642V63.6409Z",
  fill: "#8DE1FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.0224 53.4707L56.2443 53.4707C59.1836 53.4707 61.5664 51.0879 61.5664 48.1486L61.5664 24.3752C61.5664 21.4359 59.1836 19.0531 56.2443 19.0531L21.0224 19.0531C18.0831 19.0531 15.7003 21.4359 15.7003 24.3752L15.7003 48.1486C15.7003 51.0879 18.0831 53.4707 21.0224 53.4707Z",
  fill: "#0055FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.4283 53.4717V38.1939C37.4283 37.7928 37.1674 37.4668 36.8465 37.4668H24.4373C24.1164 37.4668 23.8555 37.7928 23.8555 38.1939V53.4717H37.4283Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.8126 24.1129C34.8034 24.1129 34.7943 24.1129 34.7852 24.1129V19.0527H42.4805V24.1129C42.4805 26.2383 40.7582 27.9605 38.6328 27.9605C36.675 27.9605 35.0604 26.4982 34.8177 24.6064H34.8166V24.5962C34.7963 24.4378 34.7852 24.2774 34.7852 24.1129H34.8126Z",
  fill: "#132C67"
}), /*#__PURE__*/React.createElement("path", {
  d: "M53.8751 58.2597C53.4314 58.2597 52.9846 58.1419 52.5784 57.8941L43.9417 52.6167C42.7678 51.8997 42.3982 50.3664 43.1151 49.1925C43.8321 48.0176 45.3654 47.6489 46.5393 48.3659L55.176 53.6433C56.3499 54.3602 56.7195 55.8936 56.0026 57.0675C55.5334 57.8362 54.7139 58.2597 53.8751 58.2597Z",
  fill: "#8DE1FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M53.5379 52.5833C49.8223 51.6369 46.0315 53.8872 45.085 57.5978C44.625 59.3962 44.8941 61.2667 45.8406 62.864C46.788 64.4604 48.3214 65.5195 50.0985 66.0526C53.9461 67.2072 58.8133 68.6766 61.0666 69.3184H71L70.8091 58.3695C70.144 58.1207 69.4484 57.8537 68.7416 57.5825C64.8798 56.0989 60.0725 54.2518 53.5379 52.5833Z",
  fill: "#8DE1FF"
}));

function SvgWithoutPackaging(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 80,
    viewBox: "0 0 72 80",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3572_201942",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 8,
    width: 65,
    height: 65
  }, _ref3), _ref4);
}

var ForwardRef = React.forwardRef(SvgWithoutPackaging);
export default __webpack_public_path__ + "static/media/without-packaging.ca2f9a49.svg";
export { ForwardRef as ReactComponent };